// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"df050876","83":"240b628e","89":"909561e8","159":"3efb0acf","169":"fe330192","170":"ec50b5a2","243":"224547bd","270":"46021696","357":"7bb1ec32","682":"7655ac15","736":"06fc1b13","793":"710cd3ca","833":"535de034","894":"2a2c668d","925":"bd7da068"}[chunkId] + ".js";
};